import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Button,
  Breadcrumbs,
  Link,
  Typography,
  Icon,
} from "@material-ui/core";
import { Link as linkIcon } from "react-router-dom";
import AddCircle from "@material-ui/icons/AddCircle";

// Components
import CampaignSearchTable from "./CampaignSearchTable";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      color: "white",
    },
  },
}));

const CampaignSearchHome = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* Title & Breadcrumbs */}
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Campaign </Typography>
          </Grid>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit"> Active </Link>
            </Breadcrumbs>
          </Grid>
        </Grid>
        {/* Action Row */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid container direction="row" justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  component={linkIcon}
                  to="/campaign/active"
                  startIcon={<AddCircle />}
                >
                  Create Campaign
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* Table */}
        <Grid item xs={12}>
          <CampaignSearchTable />
        </Grid>
      </Grid>
    </div>
  );
};

export default CampaignSearchHome;
